

  let scriptLoadingPromise: Promise<void> | null = null;

export const loadGoogleMapsScript = (): Promise<void> => {
  if (scriptLoadingPromise) return scriptLoadingPromise;

  scriptLoadingPromise = new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve();
      return;
    }

    const existingScript = document.getElementById("google-maps-script") as HTMLScriptElement;

    if (existingScript) {
      existingScript.onload = () => resolve();
      return;
    }

    const script = document.createElement("script");
    script.id = "google-maps-script";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = reject;

    document.head.appendChild(script);
  });

  return scriptLoadingPromise;
};
